module.exports = __webpack_public_path__ + "img/c4.e6262261.png";